import { Box, Button, Card, CardContent, IconButton, Tab, Tabs, Typography } from '@mui/material'
import { CloudUploadRounded, UploadFileRounded } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import useUser from '../../providers/user/user_provider';
import MainLayout from '../../layouts/main/main_layout';
import { ArrowBackRounded } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import FilterIcon from "../../assets/filter_icon.svg";
import AccessDenied from '../../components/access_denied/access_denied';
import DatGridJFileUpload from './components/data_grid/data_grid';
import UploadCsvFile from './components/upload_csv_popup/upload_csv_popup';
import { useQuery } from 'react-query';
import { downloadExcelApiCall, downloadExcelSmsWhstapp, getExcelUploadData, getNotificationBulkUploadData, UploadExcelFile, UploadExcelFileForNotification } from '../../services/user_append_service/excel_upload_list';
import { downloadFromBlob } from '../../utils/utils';
import FilterUploadFile from './components/filter_upload_file/filter_upload_file';
import { useFeedback } from '../../providers/feedback/feeedback';
import { queryClient } from '../../providers/query/query';
import Loading from '../../components/loading/loading';
import DatGridNotifications from './components/data_grid_notifications/notifications_grid';
import UploadCsvFileForNotification from './components/upload_csv_popup/upload_csv_for_notification';
import { ToolbarButton } from '../../components/toolbar_button/toolbar_button';
import { black, greyEnabled, purple, purpleLight } from '../../theme/colors';

export const fileLabels: { label: string }[] = [
  { label: "Sl. No." },
  { label: "Document Name" },
  { label: "Upload Date" },
  { label: "Uploaded By" },
  { label: "Status" },
  { label: "Actions" },
];

export const notificationsLabel: { label: string }[] = [
  { label: "Sl. No." },
  { label: "Document Name" },
  { label: "Upload Date" },
  { label: "Time Stamp" },
  { label: "Type of notifications" },
  { label: "Uploaded By" },
  { label: "Status" },
  { label: "Actions" },
];


export default function FileUpload() {
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopupForNotification, setOpenPopupForNotification] = useState(false);
  const { hasPermission } = useUser();
  const [page, setPage] = useState(1);
  const [pageForSms, setPageForSms] = useState(1);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDateForSms, setStartDateForSms] = useState("");
  const [endDateForSms, setEndDateForSms] = useState("");
  const [openfilterModel, setFilterModelOpen] = useState(false)
  const [openfilterSmsModel, setFilterSmsModelOpen] = useState(false)
  const { showSnackbar } = useFeedback();
  const [status, setStatus] = useState<number | null>(null);
  const [statusForSms, setStatusForSms] = useState<number | null>(null);
  const [currentTab, setCurrentTab] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [notificationSentMode, setNotificationSentMode] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const isNotificationsTab = currentTab === 2;

  const handleChange = (event: React.SyntheticEvent, currentTabVal: number) => {
    setCurrentTab(currentTabVal);
  };

  // These two queries used to run unconditionally on every render regardless
  // of which tab was active, doubling the API calls made on every page load
  // and tab switch. Each is now only enabled while its own tab is showing.
  const { data: excelUploadList, isLoading, isError } = useQuery(["excelUploadList",
    currentTab,
    page,
    startDate,
    endDate,
    status
  ], async () => {
    let response = await getExcelUploadData(
      {
        page: page,
        size: 8,
        type: currentTab === 0 ? 'edit' : 'add',
        startDate: startDate,
        endDate: endDate,
        status: status
      }
    );
    return response?.data?.data?.data;
  }, { enabled: !isNotificationsTab });

  const { data: notificationUploadList, isLoading: isNotificationsLoading, isError: isNotificationsError } = useQuery(["notificationUploadList",
    pageForSms,
    startDateForSms,
    endDateForSms,
    statusForSms
  ], async () => {
    let response = await getNotificationBulkUploadData(
      {
        page: pageForSms,
        size: 8,
        startDate: startDateForSms,
        endDate: endDateForSms,
        status: statusForSms
      }
    );
    return response?.data?.data?.data;
  }, { enabled: isNotificationsTab });



  function uploadFile(file: File) {
    setIsUploading(true);
    UploadExcelFile({ file: file, type: currentTab === 0 ? 'edit' : 'add' }).then((res) => {
      if (res.status === 200) {
        showSnackbar("Document uploaded successfully");
        queryClient.invalidateQueries({ queryKey: ["excelUploadList"] });
        setOpenPopup(false);
      }
    }).catch((error) => {
      showSnackbar(error?.response?.data?.error?.message || "Something went wrong while uploading the document.");
    }).finally(() => setIsUploading(false));
  }

  function uploadFileForNotificationApi(file: File) {
    setIsUploading(true);
    UploadExcelFileForNotification({ file: file, type: notificationSentMode.toLowerCase() }).then((res) => {
      if (res.status === 200) {
        showSnackbar("Document uploaded successfully");
        queryClient.invalidateQueries({ queryKey: ["notificationUploadList"] });
        setOpenPopupForNotification(false);
      }
    }).catch((error) => {
      showSnackbar(error?.response?.data?.error?.message || "Something went wrong while uploading the document.");
    }).finally(() => setIsUploading(false));
  }

  function downloadFile({ taskId }: { taskId: number }) {
    downloadExcelApiCall({ taskId: taskId }).then((response) => {
      downloadFromBlob(response, new Date().valueOf() + ".xlsx");
    }).catch(() => {
      showSnackbar("Something went wrong while downloading the file.");
    })
  }

  function downloadFileForSmsWhatsappNotificationApiCall({
    taskId, typeOfNotification }:
    { taskId: number, typeOfNotification: string }) {
    downloadExcelSmsWhstapp({ taskId: taskId, typeOfNotification: typeOfNotification }).
      then((response) => {
        downloadFromBlob(response, new Date().valueOf() + ".xlsx");
      }).catch(() => {
        showSnackbar("Something went wrong while downloading the file.");
      })
  }

  const handleBackClick = () => {
    const currPage = Number(searchParams.get("page")) || 1;
    if (currPage > 1) {
      const newPage = currPage - 1;
      setPage?.(newPage);
      setPageForSms(newPage)
      setSearchParams(prev => {
        const params = new URLSearchParams(prev);
        params.set("page", (newPage).toString());
        return params;
      }, { replace: true });

    }
  };

  useEffect(() => {
    setPage(1);
    setStartDate("");
    setEndDate("");
    setStatus(null);
  }, [currentTab])

  return (
    <MainLayout>
      <Box>
        <Box display="flex" alignItems="center" gap={1.5} mb={2}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 44,
              height: 44,
              borderRadius: 2,
              bgcolor: purpleLight,
              flexShrink: 0,
            }}
          >
            <CloudUploadRounded sx={{ color: purple, fontSize: 24 }} />
          </Box>
          <Box>
            <Typography variant="h5" fontWeight={700} color={black}>
              Bulk Processing
            </Typography>
            <Typography variant="body2" color={greyEnabled}>
              Upload and track bulk customer and notification files.
            </Typography>
          </Box>
        </Box>

        <Card
          elevation={0}
          sx={{ width: "100%", borderRadius: 3, border: "1px solid #ECECEC" }}
        >
          {hasPermission("jobs", "read") ? (
            <Box display="flex" flexDirection={"column"} sx={{ width: "100%" }}>
              <CardContent sx={{ p: { xs: 2.5, sm: 3 }, pb: 0 }}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  flexWrap="wrap"
                  gap={2}
                >
                  <Box display="flex" alignItems="center" gap={1}>
                    {page > 1 && (
                      <IconButton onClick={handleBackClick}>
                        <ArrowBackRounded />
                      </IconButton>
                    )}
                  </Box>
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <ToolbarButton
                      icon={FilterIcon}
                      label="Filters"
                      onClick={() => isNotificationsTab ? setFilterSmsModelOpen(true) : setFilterModelOpen(true)}
                    />
                    {hasPermission("jobs", "create") && (
                      <Button
                        variant="contained"
                        disableElevation
                        startIcon={<UploadFileRounded sx={{ height: 18, width: 18 }} />}
                        onClick={() => isNotificationsTab ? setOpenPopupForNotification(true) : setOpenPopup(true)}
                        sx={{
                          bgcolor: purple,
                          borderRadius: 2,
                          textTransform: "none",
                          fontWeight: 600,
                          "&:hover": { bgcolor: "#7A2074" },
                        }}
                      >
                        Upload File
                      </Button>
                    )}
                  </Box>
                </Box>

                <Tabs
                  value={currentTab}
                  aria-label="bulk processing tabs"
                  onChange={handleChange}
                  TabIndicatorProps={{
                    style: { backgroundColor: purple, height: 3, borderRadius: 3 },
                  }}
                  sx={{ borderBottom: "1px solid #ECECEC", mt: 2 }}
                >
                  <Tab
                    label="Edited Customers"
                    sx={{ textTransform: "none", fontWeight: 600, color: greyEnabled, "&.Mui-selected": { color: purple } }}
                  />
                  <Tab
                    label="New Customers"
                    sx={{ textTransform: "none", fontWeight: 600, color: greyEnabled, "&.Mui-selected": { color: purple } }}
                  />
                  <Tab
                    label="Notifications"
                    sx={{ textTransform: "none", fontWeight: 600, color: greyEnabled, "&.Mui-selected": { color: purple } }}
                  />
                </Tabs>
              </CardContent>

              {isNotificationsTab ? (
                <DatGridNotifications
                  label={notificationsLabel}
                  count={notificationUploadList?.total || 0}
                  data={notificationUploadList?.list || []}
                  page={pageForSms}
                  setPage={setPageForSms}
                  isLoading={isNotificationsLoading}
                  isError={isNotificationsError}
                  downloadExcel={(taskId, typeOfNotification) => {
                    downloadFileForSmsWhatsappNotificationApiCall({
                      taskId: taskId,
                      typeOfNotification: typeOfNotification
                    })
                  }}
                />
              ) : (
                <DatGridJFileUpload
                  label={fileLabels}
                  count={excelUploadList?.total || 0}
                  data={excelUploadList?.list || []}
                  page={page}
                  setPage={setPage}
                  isLoading={isLoading}
                  isError={isError}
                  downloadExcel={(taskId) => {
                    downloadFile({ taskId: taskId })
                  }}
                />
              )}
            </Box>
          ) : (
            <Box display="flex" flex={1} width="100%" height="100vh">
              <AccessDenied />
            </Box>
          )}
        </Card>
        {openPopup && <UploadCsvFile
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          uploadFile={(file: File) => {
            uploadFile(file)
          }}
          currentTab={currentTab}
          submitting={isUploading}
        />}
      </Box>
      {openPopupForNotification && <UploadCsvFileForNotification
        openPopup={openPopupForNotification}
        setOpenPopup={setOpenPopupForNotification}
        uploadFile={(file: File) => {
          uploadFileForNotificationApi(file)
        }}
        currentTab={currentTab}
        notificationSentMode={notificationSentMode}
        setNotificationSentMode={setNotificationSentMode}
        submitting={isUploading}
      />}
      {openfilterModel && <FilterUploadFile
        statusList={[
          { id: 1, value: 'In Progress' },
          { id: 2, value: 'Completed' },
          { id: 3, value: 'failed' }
        ]}
        startDate={startDate}
        endDate={endDate}
        openModal={openfilterModel}
        resetFilter={() => {
          setStartDate("");
          setEndDate("");
          setPage(1);
          setStatus(null);
        }}
        setEndDate={setEndDate}
        setOpenModal={setFilterModelOpen}
        setStartDate={setStartDate}
        setStatus={setStatus}
        status={status}
      />}
      {openfilterSmsModel && <FilterUploadFile
        statusList={[
          { id: 1, value: 'In Progress' },
          { id: 3, value: 'Completed' },
          { id: 2, value: 'failed' }
        ]}
        endDate={endDateForSms}
        startDate={startDateForSms}
        openModal={openfilterSmsModel}
        resetFilter={() => {
          setStartDateForSms("");
          setEndDateForSms("");
          setPageForSms(1);
          setStatusForSms(null);
        }}
        setEndDate={setEndDateForSms}
        setOpenModal={setFilterSmsModelOpen}
        setStartDate={setStartDateForSms}
        setStatus={setStatusForSms}
        status={statusForSms}
      />}
    </MainLayout>
  )
}
